<template>
	<footer class="footer">
		<div class="inner footer__inner">
			<div class="footer__box">
				<div class="footer__text">ИП Шахрай Светлана Михайловна</div>
				<div class="footer__text">ИНН: 263500194811"</div>
				<div class="footer__text">ОГРН: 305263515900181"</div>
			</div>
			<div class="footer__box">
				<a href="tel:+7 (968) 267-52-23" class="footer__text footer__text_link">8-968-267-52-23</a>
				<a href="mailto:keklik.braslets@yandex.ru" class="footer__text footer__text_link">keklik.braslets@yandex.ru</a>
				<template>
				  <div class="tg-contact">
				    <a class="tg-contact__link" href="https://t.me/stasy_pilipenko" target="_blank" rel="noopener noreferrer" aria-label="Telegram">
				      <svg class="tg-contact__icon" width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
				        <circle class="tg-contact__icon-bg" cx="12" cy="12" r="12" fill="currentColor"/>
				        <path class="tg-contact__icon-plane" d="M17.598 8.22l-1.636 7.706c-.124.554-.447.69-.907.43l-2.5-1.842-1.207 1.16c-.134.134-.246.246-.504.246l.18-2.544 4.63-4.184c.2-.18-.044-.28-.312-.1l-5.724 3.604-2.466-.77c-.536-.166-.546-.536.112-.794l9.638-3.716c.446-.16.836.11.696.804Z" fill="#fff"/>
				      </svg>
				      <span class="tg-contact__tooltip">Для срочных вопросов по&nbsp;работе сайта пишите @stasy_pilipenko</span>
				    </a>
				  </div>
				</template>
			</div>
			<div class="footer__box">
				<router-link to="/information" class="footer__text footer__text_link">Порядок оказания услуг и возврата</router-link>
				<router-link to="/tariffs" class="footer__text footer__text_link">Тарифы</router-link>
				<a target="_blank" href="/files/public-oferta.pdf" class="footer__text footer__text_link">Договор-оферта</a>
			</div>
			<div class="footer__box" v-if="showLegalLinks">
				<router-link to="/personal-data" class="footer__text footer__text_link">Согласие на обработку ПД</router-link>
				<router-link to="/privacy-policy" class="footer__text footer__text_link">Политика конфиденциальности</router-link>
				<router-link to="/user-agreement" class="footer__text footer__text_link">Пользовательское соглашение</router-link>
				<router-link to="/cookie-policy" class="footer__text footer__text_link">Политика использования cookie</router-link>
				<router-link to="/ads-consent" class="footer__text footer__text_link">Согласие на получение рекламной информации</router-link>
				<router-link to="/yandex-metrika" class="footer__text footer__text_link">Яндекс.Метрика</router-link>
			</div>
		</div>
	</footer>
</template>

<script>
	export default {
		data() {
			return {
				showLegalLinks: true,
			}
		},
	}
</script>

<style src="./footer.less" lang="less" />
